import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Divider, Grid } from "@mui/material";
import { Button } from "common/styles/muiStyled";
import { Routes } from "routes";
import { IProduct, Nullable } from "../../../../../common/types";

interface Props {
  onReset: () => void;
  disabledSubmit: boolean;
  handleSubmitClick: () => void;
  selectedPaidProduct: Nullable<IProduct>;
  hasPaidProducts?: boolean;
  hideClearButton?: boolean;
  hideSubmitButton?: boolean;
}

const ActionButtonsGroup: FC<Props> = ({
   onReset,
   disabledSubmit,
   handleSubmitClick,
   selectedPaidProduct,
   hasPaidProducts,
   hideSubmitButton,
   hideClearButton
 }) => {
  const history = useNavigate();
  const { t } = useTranslation("common");

  return (
    <Grid item xs={12} sx={{ pt: 3 }}>
      <Divider sx={{ mt: 2 }} />
      <Grid container sx={{ pt: 1 }}>
        <Grid item xs={12} sm={4} sx={{ pt: 1, pb: 1 }}>
          {!hideClearButton && (
            <Button variant="outlined" onClick={onReset} data-testid="clear-badge-form-button">
              {t("common.buttonLabels.clearForm")}
            </Button>
          )}
        </Grid>
        <Grid item xs={12} sm={8} sx={{ pt: 1, pb: 1, display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="text"
            onClick={() => {
              history(Routes.badges);
            }}
            data-testid="cancel-badge-form-button"
            sx={{ mr: 2 }}
          >
            {t("common.buttonLabels.cancel")}
          </Button>
          {!hideSubmitButton && (
            <Button
              type="submit"
              variant="contained"
              disabled={disabledSubmit}
              data-testid="register-badge-form-button"
              onClick={handleSubmitClick}
            >
              {hasPaidProducts ? t("common.buttonLabels.reviewOrder") : t("common.buttonLabels.register")}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ActionButtonsGroup;
